import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchAclConditions } from 'common/services/api/Acls/AclConditions.thunk';
import { AclCondition } from 'common/types/Entities';

type AclConditionsState = {
    aclConditions: AclCondition[],
    loaded: boolean
}

const initialState: AclConditionsState = {
    aclConditions: [],
    loaded: false
};

const aclConditionsSlice = createSlice({
    name: 'aclConditions',
    initialState,
    reducers: () => ({}),

    extraReducers: builder => {
        builder.addCase(fetchAclConditions.pending, state => {
            state.loaded = false;
            state.aclConditions = [];
        });
        builder.addCase(fetchAclConditions.fulfilled, (state, action: PayloadAction<AclCondition[]>) => {
            state.loaded = true;
            state.aclConditions = action.payload;
        });
        builder.addCase(fetchAclConditions.rejected, state => {
            state.loaded = false;
            state.aclConditions = [];
        });
    }
});

// eslint-disable-next-line no-restricted-syntax
export default aclConditionsSlice.reducer;
